// Central data: services, products, industries, tech stack, testimonials, metrics
export const COMPANY = {
  name: "CloudLab Technologies",
  short: "CloudLab",
  logo: "https://customer-assets-jai6qajn.emergentagent.net/job_ai-solutions-lab-22/artifacts/gqgfbl7e_cloud%20lab%20logo%20pn.png",
  tagline: "AI engineering that automates the enterprise.",
  description:
    "We architect intelligent AI systems, autonomous agents, and enterprise software that transform how ambitious companies operate.",
  markets: ["United Kingdom", "Pakistan", "United States", "Germany", "Saudi Arabia", "UAE"],
  email: "sales@cloudlabweb.com",
  website: "https://www.cloudlabweb.com",
  phone: "+44 73 8088 5506",
  address: "Karachi · Islamabad · Glasgow",
  socials: {
    linkedin: "https://www.linkedin.com/company/cloudlabweb",
    twitter: "https://x.com/cloudlabweb",
  },
};

export const OFFICES = [
  {
    id: "uk",
    country: "United Kingdom",
    countryCode: "GB",
    flag: "🇬🇧",
    city: "Glasgow",
    label: "Head Office",
    address: "6 Range Gate, G53 7UB, Glasgow, Scotland, United Kingdom",
    phone: "+44 73 8088 5506",
    email: "sales@cloudlabweb.com",
    map: "https://www.google.com/maps/search/?api=1&query=6+Range+Gate+G53+7UB+Glasgow+Scotland",
    tz: "GMT · UTC+0",
    hours: "Mon–Fri · 09:00 – 18:00",
  },
  {
    id: "karachi",
    country: "Pakistan",
    countryCode: "PK",
    flag: "🇵🇰",
    city: "Karachi",
    label: "Regional Office",
    address: "Office No. 413, Business Arcade, Shahra-e-Faisal, Karachi, Pakistan",
    phone: "+92 345 5222 000",
    email: "sales@cloudlabweb.com",
    map: "https://www.google.com/maps/search/?api=1&query=Business+Arcade+Shahrah-e-Faisal+Karachi",
    tz: "PKT · UTC+5",
    hours: "Mon–Fri · 10:00 – 19:00",
  },
  {
    id: "islamabad",
    country: "Pakistan",
    countryCode: "PK",
    flag: "🇵🇰",
    city: "Islamabad · Rawalpindi",
    label: "Regional Office",
    address: "The Gateway Building, 251 Spring North Commercial, Phase 7 Bahria Town, Rawalpindi, Pakistan",
    phone: "+92 345 5222 000",
    email: "sales@cloudlabweb.com",
    map: "https://www.google.com/maps/search/?api=1&query=The+Gateway+Building+Phase+7+Bahria+Town+Rawalpindi",
    tz: "PKT · UTC+5",
    hours: "Mon–Fri · 10:00 – 19:00",
  },
];

export const SERVICES = [
  { slug: "mobile-app-development", name: "Mobile Application Development", icon: "Smartphone",
    number: "02", category: "Android / iOS",
    tagline: "Native-quality apps for iOS and Android that customers love.",
    description: "Our team of experts specializes in creating high-quality, feature-rich mobile apps that can help you connect with customers professionally — from consumer apps to field-force tooling.",
    benefits: ["Native + React Native", "Offline-first architecture", "App Store optimization", "Push + realtime sync"],
    tech: ["React Native", "Swift", "Kotlin", "Expo", "Firebase"] },
  { slug: "crm-development", name: "CRM Development", icon: "Users2",
    number: "07", category: "Programming",
    tagline: "Custom CRMs shaped around your pipeline, channels and people.",
    description: "Bespoke sales, service, admissions and field-force CRMs — with AI copilots baked in and native WhatsApp, voice and email capture.",
    benefits: ["Custom sales & admissions CRMs", "AI copilots + lead scoring", "WhatsApp / voice / email native", "Own the code, IP & data"],
    tech: ["React", "Node.js", "PostgreSQL", "WhatsApp API", "Twilio"] },
  { slug: "saas-development", name: "SaaS Development", icon: "Rocket",
    number: "10", category: "Programming",
    tagline: "Investor-ready MVPs and multi-tenant platforms built to raise, sell and scale.",
    description: "From napkin to first paying customer — SaaS MVPs, multi-tenant platforms, SSO/RBAC, Stripe billing and product analytics engineered end-to-end.",
    benefits: ["8–12 wk MVPs", "Multi-tenant + SSO/RBAC", "Stripe billing & usage pricing", "PostHog / Mixpanel wired in"],
    tech: ["Next.js", "TypeScript", "PostgreSQL", "Stripe", "Vercel"] },
  // ------- Phase 3.1 canonical service pages -------
  { slug: "ai-development", name: "AI Development", icon: "Sparkles",
    number: "12", category: "AI & Automation",
    tagline: "Production AI systems — copilots, agents, document intelligence.",
    description: "AI development for real-world business automation. LLM copilots, AI agents, voice agents and document intelligence integrated into your existing software, workflows and data.",
    benefits: ["LLM copilots on your data", "Voice + WhatsApp AI agents", "Document intelligence", "Guardrailed & auditable"],
    tech: ["OpenAI", "Claude", "Gemini", "LangChain", "Pinecone"] },
  { slug: "ai-agent-development", name: "AI Agent Development", icon: "Bot",
    number: "13", category: "AI & Automation",
    tagline: "Autonomous agents that finish tasks — not just chat.",
    description: "AI agent development for real operations. Task-completing agents that qualify leads, book meetings, raise tickets and orchestrate across your existing tools with a supervised, auditable loop.",
    benefits: ["Multi-tool orchestration", "Voice, WhatsApp, chat, email", "Human-in-the-loop review", "Every action logged"],
    tech: ["LangGraph", "OpenAI", "Retell", "Twilio", "Vector DBs"] },
  { slug: "custom-software-development", name: "Custom Software Development", icon: "Layers",
    number: "14", category: "Software & Platforms",
    tagline: "Bespoke systems for the operations that matter.",
    description: "Custom software development for businesses that have outgrown spreadsheets, off-the-shelf SaaS or legacy systems. Bespoke platforms, enterprise back-office, integrations and internal tooling.",
    benefits: ["Own the code and IP", "Structured written scope", "Integrated with your stack", "Scale-ready foundation"],
    tech: ["React", "Next.js", "Node.js", "PostgreSQL", "AWS"] },
  { slug: "web-application-development", name: "Web Application Development", icon: "LayoutDashboard",
    number: "15", category: "Software & Platforms",
    tagline: "SaaS, dashboards, portals and marketplaces built to scale.",
    description: "Web application development for serious business software — SaaS platforms, admin dashboards, customer portals, marketplaces and internal tools. SEO-first, 95+ Lighthouse, real-time where you need it.",
    benefits: ["SSR-ready + SEO-first", "Real-time at scale", "RBAC + audit logs", "Modular architecture"],
    tech: ["React", "Next.js", "TypeScript", "PostgreSQL", "Redis"] },
  { slug: "edtech-development", name: "EdTech Software Development", icon: "GraduationCap",
    number: "16", category: "Industry Solutions",
    tagline: "Admissions, LMS, student portals, campus ERPs and AI for education.",
    description: "EdTech software development for universities, colleges, education agencies and EdTech founders. Admissions CRMs, LMS platforms, student portals, campus ERPs and AI-assisted admissions.",
    benefits: ["Full student-journey stack", "AI-native admissions", "Multi-campus by default", "Own code and student data"],
    tech: ["React", "Next.js", "PostgreSQL", "OpenAI", "React Native"] },
  { slug: "mvp-development", name: "MVP Development", icon: "Rocket",
    number: "17", category: "Product Development",
    tagline: "Idea → prototype → MVP → first paying customer in 8–12 weeks.",
    description: "MVP development for founders and product teams. Investor-ready SaaS, AI-native and mobile MVPs with auth, one killer workflow, billing and dashboards — enough to onboard real users or raise a round.",
    benefits: ["8–12 wk to production", "Real users on real infra", "Scale-ready foundation", "Analytics + billing baked in"],
    tech: ["Next.js", "React Native", "Stripe", "PostgreSQL", "Vercel"] },
  { slug: "software-modernisation", name: "Software Modernisation", icon: "Wrench",
    number: "18", category: "Software & Platforms",
    tagline: "Legacy replatform, cloud migration and AI-enablement — incrementally.",
    description: "Software modernisation without a big-bang rewrite. We modernise legacy PHP, .NET, VB, Java and desktop systems in structured increments — extract business logic, move to cloud-native, add AI, keep the lights on.",
    benefits: ["Zero-downtime cutover", "Incremental — never big-bang", "AI on top of legacy", "Own the modernised code"],
    tech: ["React", ".NET", "Node.js", "AWS", "Kubernetes"] },
];

export const PRODUCTS = [
  { slug: "acadmax-erp", name: "Acadmax — ERP", tagline: "The complete ERP for schools, colleges and universities.",
    description: "One platform for admissions, fee management, academics, exams, HR, payroll and reporting — engineered for modern educational institutions across four continents.",
    features: ["Admissions + fee automation", "Academic + exam management", "HR, payroll & finance", "Real-time analytics"],
    industries: ["Education", "Universities", "K-12 Schools"],
    image: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=940&q=80" },
  { slug: "teachingsoftware-ai", name: "TeachingSoftware.ai", tagline: "AI teaching assistant that plans, grades and personalises for every student.",
    description: "An AI copilot for teachers — lesson planning, assessments, grading, feedback and adaptive learning paths, wired directly into your LMS.",
    features: ["AI lesson planner", "Auto-grading + feedback", "Adaptive learning paths", "LMS + SIS integration"],
    industries: ["Education", "Corporate Training"],
    image: "https://images.pexels.com/photos/14314636/pexels-photo-14314636.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { slug: "libmax", name: "Libmax", tagline: "Next-gen library management for libraries of any scale.",
    description: "A modern library platform with cataloguing, circulation, digital resources, RFID and patron self-service — for school, university and public libraries.",
    features: ["Cataloguing + circulation", "RFID + barcode ready", "Digital resources + eBooks", "Patron self-service"],
    industries: ["Education", "Public Libraries", "Universities"],
    image: "https://images.unsplash.com/photo-1521587760476-6c12a4b040da?auto=format&fit=crop&w=940&q=80" },
  { slug: "unicrm-ai", name: "UniCrm.ai", tagline: "AI-native CRM for universities and higher-education recruitment.",
    description: "From enquiry to enrolment — capture, qualify and nurture prospective students across web, WhatsApp, voice and email with AI copilots at every step.",
    features: ["Omni-channel enquiry capture", "AI lead scoring + nurturing", "Enrolment pipeline", "Counsellor copilot"],
    industries: ["Education", "Universities", "Recruitment"],
    image: "https://images.pexels.com/photos/17489153/pexels-photo-17489153.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { slug: "hellosir-ai", name: "HelloSir.ai", tagline: "Enterprise AI concierge across web, voice and chat.",
    description: "One AI agent that answers on your website, WhatsApp, calls and email — trained on your business.",
    features: ["Web chat + voice widget", "WhatsApp + email channels", "CRM handoff", "Lead scoring"],
    industries: ["Real Estate", "Healthcare", "Hospitality", "SaaS"],
    image: "https://images.unsplash.com/photo-1758073519996-6d3c63b4922c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHw0fHxhYnN0cmFjdCUyMGdsb3dpbmclMjBuZXVyYWwlMjBuZXR3b3JrJTIwZGFya3xlbnwwfHx8fDE3ODQ5MTgwODF8MA&ixlib=rb-4.1.0&q=85" },
  { slug: "visainterviews-ai", name: "VisaInterviews.ai", tagline: "AI-powered visa interview coaching for students and professionals.",
    description: "Realistic AI mock interviews for US, UK, Canada and Schengen visas — with instant feedback on answers, tone and confidence, trained on real consular questions.",
    features: ["Realistic AI mock interviews", "Instant feedback + scoring", "Country-specific question banks", "Voice + video practice"],
    industries: ["Education", "Immigration", "Consulting"],
    image: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=940&q=80" },
];

export const INDUSTRIES = [
  { slug: "education", name: "Education", icon: "GraduationCap", blurb: "AI tutors, adaptive learning, LMS at scale.",
    image: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=800&q=80" },
  { slug: "healthcare", name: "Healthcare", icon: "HeartPulse", blurb: "EMRs, AI scribes, patient engagement.",
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?auto=format&fit=crop&w=800&q=80" },
  { slug: "real-estate", name: "Real Estate", icon: "Building", blurb: "AI lead qualification, virtual agents, CRM.",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=800&q=80" },
  { slug: "construction", name: "Construction", icon: "HardHat", blurb: "Project intelligence, procurement, safety AI.",
    image: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=800&q=80" },
  { slug: "hospitality", name: "Hospitality", icon: "UtensilsCrossed", blurb: "Concierge AI, booking, ops automation.",
    image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=800&q=80" },
  { slug: "manufacturing", name: "Manufacturing", icon: "Factory", blurb: "Predictive maintenance, quality AI, ERP.",
    image: "https://images.unsplash.com/photo-1565043666747-69f6646db940?auto=format&fit=crop&w=800&q=80" },
  { slug: "retail", name: "Retail", icon: "ShoppingBag", blurb: "Personalisation, inventory, agent commerce.",
    image: "https://images.unsplash.com/photo-1607083206869-4c7672e72a8a?auto=format&fit=crop&w=800&q=80" },
  { slug: "financial-services", name: "Financial Services", icon: "Landmark", blurb: "Risk models, KYC, compliance AI.",
    image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&w=800&q=80" },
  { slug: "travel", name: "Travel", icon: "Plane", blurb: "Dynamic pricing, itinerary agents, ops.",
    image: "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?auto=format&fit=crop&w=800&q=80" },
  { slug: "logistics", name: "Logistics", icon: "Truck", blurb: "Route optimisation, tracking, forecasting.",
    image: "https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?auto=format&fit=crop&w=800&q=80" },
  { slug: "government", name: "Government", icon: "Landmark", blurb: "Secure AI, citizen services, e-gov.",
    image: "https://images.unsplash.com/photo-1583452030489-ec5b3ab0adc4?auto=format&fit=crop&w=800&q=80" },
];

export const TECH_STACK = [
  { name: "OpenAI",       key: "openai",       cat: "AI" },
  { name: "Claude",       key: "anthropic",    cat: "AI" },
  { name: "Gemini",       key: "gemini",       cat: "AI" },
  { name: "React",        key: "react",        cat: "Frontend" },
  { name: "Next.js",      key: "nextjs",       cat: "Frontend" },
  { name: "Angular",      key: "angular",      cat: "Frontend" },
  { name: "Vue.js",       key: "vuejs",        cat: "Frontend" },
  { name: "Flutter",      key: "flutter",      cat: "Mobile" },
  { name: "Android",      key: "android",      cat: "Mobile" },
  { name: "Kotlin",       key: "kotlin",       cat: "Mobile" },
  { name: "Swift",        key: "swift",        cat: "Mobile" },
  { name: "Node.js",      key: "nodejs",       cat: "Backend" },
  { name: "Python",       key: "python",       cat: "Language" },
  { name: "TypeScript",   key: "typescript",   cat: "Language" },
  { name: "JavaScript",   key: "javascript",   cat: "Language" },
  { name: "Java",         key: "java",         cat: "Language" },
  { name: "PHP",          key: "php",          cat: "Language" },
  { name: "Go",           key: "go",           cat: "Language" },
  { name: "MongoDB",      key: "mongodb",      cat: "Data" },
  { name: "PostgreSQL",   key: "postgresql",   cat: "Data" },
  { name: "Redis",        key: "redis",        cat: "Data" },
  { name: "Docker",       key: "docker",       cat: "DevOps" },
  { name: "Kubernetes",   key: "kubernetes",   cat: "DevOps" },
  { name: "AWS",          key: "amazonwebservices", cat: "Cloud" },
  { name: "Google Cloud", key: "googlecloud",  cat: "Cloud" },
  { name: "Azure",        key: "azure",        cat: "Cloud" },
  { name: "Firebase",     key: "firebase",     cat: "Cloud" },
  { name: "GitHub",       key: "github",       cat: "DevOps" },
  { name: "Tailwind",     key: "tailwindcss",  cat: "Frontend" },
  { name: "Figma",        key: "figma",        cat: "Design" },
];

// Icon URL builder — devicon CDN with transparent PNG. `openai`, `anthropic`, `gemini`
// aren't in devicon so we map those to simpleicons.org (also transparent PNG/SVG).
export const techIconUrl = (key) => {
  const devicon = new Set([
    "react","nextjs","angular","vuejs","flutter","android","kotlin","swift",
    "nodejs","python","typescript","javascript","java","php","go",
    "mongodb","postgresql","redis","docker","kubernetes","amazonwebservices",
    "googlecloud","azure","firebase","github","tailwindcss","figma",
  ]);
  if (devicon.has(key)) {
    return `https://cdn.jsdelivr.net/gh/devicons/devicon/icons/${key}/${key}-original.svg`;
  }
  // lobe-icons for AI provider brand marks (devicon doesn't have OpenAI/Claude/Gemini)
  const lobe = {
    openai: "openai",
    anthropic: "claude-color",
    gemini: "gemini-color",
  }[key];
  if (lobe) {
    return `https://raw.githubusercontent.com/lobehub/lobe-icons/master/packages/static-svg/icons/${lobe}.svg`;
  }
  return `https://cdn.simpleicons.org/${key}`;
};

export const FEATURED_PROJECTS = [
  {
    slug: "whitmore-realty-voice-agent",
    name: "Whitmore Realty · AI Voice Agent",
    industry: "Real Estate",
    country: "United Kingdom",
    tagline: "24/7 voice qualification that outperforms human SDRs on every metric.",
    result: "3.2× more qualified viewings booked in 90 days",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "riyadh-fintech-copilot",
    name: "Riyadh FinTech · Compliance Copilot",
    industry: "Financial Services",
    country: "Saudi Arabia",
    tagline: "LLM copilot that reviews KYC packets in seconds with a full audit trail.",
    result: "82% reduction in KYC review time",
    image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "weber-logistik-agent",
    name: "Weber Logistik · Agentic Ops",
    industry: "Logistics",
    country: "Germany",
    tagline: "Autonomous agent orchestrates dispatch, tracking and driver comms.",
    result: "3,000+ human-hours saved per month",
    image: "https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "uae-medical-scribe",
    name: "MediCore UAE · Clinical Scribe",
    industry: "Healthcare",
    country: "United Arab Emirates",
    tagline: "AI scribe that writes clinical notes better than residents — HIPAA-ready.",
    result: "+40% patient-facing time for physicians",
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "karachi-edulab",
    name: "EduLab · Adaptive Learning Platform",
    industry: "Education",
    country: "Pakistan",
    tagline: "AI tutors that adapt to each student's pace, with institution-wide analytics.",
    result: "58% improvement in course completion",
    image: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "london-hospitality-concierge",
    name: "The Kensington Group · AI Concierge",
    industry: "Hospitality",
    country: "United Kingdom",
    tagline: "Multi-lingual concierge across WhatsApp, voice and web for luxury hotels.",
    result: "1.8× upsell revenue per stay",
    image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "us-manufacturing-quality",
    name: "PrecisionForge · Vision QA",
    industry: "Manufacturing",
    country: "United States",
    tagline: "Computer-vision quality control on the production line — sub-second defect detection.",
    result: "94% defect catch rate vs. 71% baseline",
    image: "https://images.unsplash.com/photo-1565043666747-69f6646db940?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "dubai-real-estate-crm",
    name: "Emirates Estates · Sales Copilot",
    industry: "Real Estate",
    country: "UAE",
    tagline: "AI-native CRM with quotation generator and lead scoring on every channel.",
    result: "2.4× agent productivity",
    image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=1200&q=80",
  },
];

export const METRICS = [
  { value: 120, suffix: "+", label: "Projects delivered" },
  { value: 40, suffix: "M+", label: "AI interactions served" },
  { value: 6, suffix: "", label: "Countries served" },
  { value: 99.9, suffix: "%", label: "Uptime SLA" },
];

export const TESTIMONIALS = [
  { quote: "CloudLab replaced our entire lead-qualification team with a voice agent that outperforms humans on every metric.", author: "Sarah Whitmore", role: "COO, Whitmore Realty", country: "United Kingdom" },
  { quote: "They shipped a production agentic system in eight weeks. It saves us over 3,000 human-hours every month.", author: "Marcus Weber", role: "CTO, Weber Logistik", country: "Germany" },
  { quote: "The most impressive engineering team we've ever partnered with. Genuine AI expertise, not slideware.", author: "Ahmed Al-Farsi", role: "VP Product, Riyadh FinTech", country: "Saudi Arabia" },
  { quote: "Our EMR now writes clinical notes better than our residents. Patient time up 40%.", author: "Dr. Fatima Khan", role: "Medical Director", country: "United Arab Emirates" },
];

export const WORKFLOW_STEPS = [
  { title: "Lead arrives", desc: "Web, WhatsApp, voice, email — every channel captured.", icon: "Inbox" },
  { title: "AI qualifies", desc: "Score, enrich, route in under 5 seconds.", icon: "Sparkles" },
  { title: "AI communicates", desc: "Personal, multi-lingual outreach at scale.", icon: "MessageSquare" },
  { title: "AI processes documents", desc: "Extract, classify, verify with 99%+ accuracy.", icon: "FileText" },
  { title: "AI schedules meetings", desc: "Calendar-aware, timezone-aware, human-native.", icon: "Calendar" },
  { title: "AI follows up", desc: "Never miss, never sleep, always context-aware.", icon: "Repeat" },
  { title: "Human takes over", desc: "Only when it matters most.", icon: "UserCheck" },
];
